import { SectionHeader, Badge, levelClass, ScoresSummary } from "@/components/workflow/ui";
import { TreatmentPlan, EvidenceReferences, FinalActions } from "@/components/workflow/parts";
import { CheckCircle2 } from "lucide-react";

export default function StepFinal({
  final, scores, user, downloading, downloadingRx, downloadingSheet, savingCase, savedId,
  downloadPdf, downloadRx, downloadCaseSheet, saveCase, reset,
}) {
  const fd = final.final_diagnosis || {};
  return (
    <div data-testid="final-section">
      <SectionHeader icon={CheckCircle2} sub="Step 7 · Outcome" title="Final diagnosis & treatment" />
      <div className="border-2 border-[#002FA7] rounded-md p-6 bg-blue-50/40">
        <div className="flex items-center justify-between gap-3">
          <h3 className="font-serif text-2xl text-zinc-900">{fd.condition}</h3>
          <Badge className={levelClass(fd.confidence)}>{fd.confidence} confidence</Badge>
        </div>
        <p className="mt-3 text-sm text-zinc-700">{fd.justification}</p>
        {fd.icd10_hint && <p className="mt-2 text-xs text-zinc-500">ICD-10: {fd.icd10_hint}</p>}
      </div>

      <TreatmentPlan treatment={final.treatment} />
      <EvidenceReferences references={final.references} />
      <ScoresSummary scores={scores} />
      <FinalActions
        user={user} downloading={downloading} downloadingRx={downloadingRx} downloadingSheet={downloadingSheet}
        savingCase={savingCase} savedId={savedId}
        downloadPdf={downloadPdf} downloadRx={downloadRx} downloadCaseSheet={downloadCaseSheet} saveCase={saveCase} reset={reset}
      />
    </div>
  );
}
